import { Collection, getFirebase } from 'firestorter';
import CollectionName from '../utils/collections';
import BaseDocument from './BaseDocument';

/**
 * Class representing Smart Context History.
 *
 * @class SmartContextHistory
 * @extends BaseDocument
 */
class SmartContextHistory extends BaseDocument {
  /**
   * Creates an instance of SmartContextHistory.
   *
   * @param {string} id - The unique identifier for the smart context history document
   * @param {Object} [opts] - Optional configuration options passed to BaseDocument
   */
  constructor(id, opts) {
    super(`${CollectionName.SMART_CONTEXT_HISTORY}/${id}`, opts);
  }

  /**
   * Adds a new smart context session to the collection.
   *
   * @static
   * @async
   * @param {Object} sessionData - The session data object
   * @param {string} sessionData.sessionId - The unique identifier for the session
   * @param {string} sessionData.response - The AI response from the session
   * @param {string} sessionData.query - The user query/input for the session
   * @param {string} sessionData.channelId - The channel identifier where the session occurred
   * @param {string} sessionData.userId - The user identifier who initiated the session
   * @returns {Promise<DocumentReference>} A Promise that resolves to the DocumentReference of the added session
   */
  static async addSession({
    sessionId, response, query, channelId, userId,
  }) {
    const smartContextHistoryCollection = new Collection(CollectionName.SMART_CONTEXT_HISTORY);

    return smartContextHistoryCollection.add({
      sessionId,
      data: response,
      query,
      channelId,
      userId,
      createdAt: getFirebase().firestore.FieldValue.serverTimestamp(),
    });
  }
}

export default SmartContextHistory;
